import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0e9dfd21"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = {
  key: 0,
  class: "live-type"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 0,
  class: "right one-live"
};
const _hoisted_5 = {
  class: "top"
};
const _hoisted_6 = {
  key: 0,
  class: "status-ing"
};
const _hoisted_7 = {
  class: "icon-anim"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "进行中", -1));

const _hoisted_9 = {
  key: 1,
  class: "status-icon"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "未开始", -1));

const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  class: "live-name text-overflow-two"
};
const _hoisted_13 = {
  class: "bottom"
};
const _hoisted_14 = {
  key: 0,
  class: "lecture-teacher"
};
const _hoisted_15 = {
  class: "teacher-photo"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "main-teacher text-overflow"
};
const _hoisted_18 = {
  class: "unit"
};
const _hoisted_19 = ["title"];
const _hoisted_20 = {
  key: 1,
  class: "lecture-teacher-more"
};
const _hoisted_21 = {
  class: "teacher-info"
};
const _hoisted_22 = {
  class: "teacher-photo"
};
const _hoisted_23 = {
  class: "photo-box"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "photo-box"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  key: 0,
  class: "photo-box"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  key: 0,
  class: "teacher-name unit"
};
const _hoisted_30 = ["title"];
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = {
  key: 0,
  class: "status-watch"
};
const _hoisted_33 = {
  key: 1,
  class: "status-start"
};
const _hoisted_34 = {
  key: 1,
  class: "bottom"
};
const _hoisted_35 = {
  key: 0,
  class: "status-watch"
};
const _hoisted_36 = {
  key: 1,
  class: "status-watch"
};
const _hoisted_37 = {
  key: 1,
  class: "right"
};
const _hoisted_38 = {
  class: "top"
};
const _hoisted_39 = {
  key: 0,
  class: "status-ing"
};
const _hoisted_40 = {
  class: "icon-anim"
};

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "进行中", -1));

const _hoisted_42 = {
  key: 1,
  class: "status-icon"
};

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "未开始", -1));

const _hoisted_44 = [_hoisted_43];
const _hoisted_45 = {
  class: "live-name text-overflow-two"
};
const _hoisted_46 = {
  key: 2,
  class: "lecture-teacher"
};
const _hoisted_47 = {
  class: "teacher-photo"
};
const _hoisted_48 = ["src"];
const _hoisted_49 = {
  class: "main-teacher text-overflow"
};
const _hoisted_50 = {
  class: "unit"
};
const _hoisted_51 = ["title"];
const _hoisted_52 = {
  key: 3,
  class: "lecture-teacher-more"
};
const _hoisted_53 = {
  class: "teacher-info"
};
const _hoisted_54 = {
  class: "teacher-photo"
};
const _hoisted_55 = {
  class: "photo-box"
};
const _hoisted_56 = ["src"];
const _hoisted_57 = {
  class: "photo-box"
};
const _hoisted_58 = ["src"];
const _hoisted_59 = {
  key: 0,
  class: "photo-box"
};
const _hoisted_60 = ["src"];
const _hoisted_61 = {
  key: 0,
  class: "teacher-name unit"
};
const _hoisted_62 = ["title"];
const _hoisted_63 = {
  key: 0
};
const _hoisted_64 = {
  key: 0,
  class: "status-watch"
};
const _hoisted_65 = {
  key: 1,
  class: "status-start"
};
const _hoisted_66 = {
  class: "lecture-adress text-overflow"
};

const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "培训地点：", -1));

const _hoisted_68 = {
  key: 0,
  class: "status-watch"
};
import LiveIcon from '@/pages/components/liveIcon';
export default {
  props: {
    lectureData: Object,
    menu: Object,
    lectureCount: Number // 直播数量

  },

  setup(__props) {
    const props = __props;

    const demoAvatar = require('@/assets/images/common/teacher_icon.png');

    const defaultCover = computed(() => {
      return props.lectureData.type == 1 ? 'lecture_online1' : 'lecture_offline1';
    });
    const teacherInfo = computed(() => {
      return props.lectureData.teacherDtoList || [];
    });

    const goDetail = id => {
      window.open(`/lectureDetail.html?menuId=${props.menu.menu_id}&name=${props.menu.nav_name || props.menu.module_name}&id=${id}`);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["live-card", {
          'one-live-card': __props.lectureCount == 1
        }]),
        onClick: _cache[0] || (_cache[0] = $event => goDetail(__props.lectureData.id))
      }, [_createElementVNode("div", _hoisted_1, [__props.lectureData.classify_name ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.lectureData.classify_name), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
        src: __props.lectureData.live_cover_url || require(`@/assets/images/lecture/${_unref(defaultCover)}.png`),
        alt: ""
      }, null, 8, _hoisted_3)]), __props.lectureCount === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [__props.lectureData.live_status == -2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createVNode(_unref(LiveIcon))]), _hoisted_8])) : _createCommentVNode("", true), __props.lectureData.live_status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_12, _toDisplayString(__props.lectureData.live_name), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_unref(teacherInfo).length && _unref(teacherInfo).length < 2 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
        src: _unref(teacherInfo)[0].file_url ? _unref(teacherInfo)[0].file_url : _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(_unref(teacherInfo).length ? _unref(teacherInfo)[0].teacher_name : '暂无信息'), 1), _createElementVNode("span", {
        class: "intro",
        title: `${_unref(teacherInfo)[0].school_name ? _unref(teacherInfo)[0].school_name : ''} ${__props.lectureData.teacherDtoList[0].college_name ? _unref(teacherInfo)[0].college_name : ''} ${_unref(teacherInfo)[0].job_title ? _unref(teacherInfo)[0].job_title : ''}`
      }, "  " + _toDisplayString(_unref(teacherInfo)[0].school_name) + " " + _toDisplayString(_unref(teacherInfo)[0].college_name) + " " + _toDisplayString(_unref(teacherInfo)[0].job_title), 9, _hoisted_19)])])) : _createCommentVNode("", true), _unref(teacherInfo).length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
        src: _unref(teacherInfo)[0].file_url || _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
        src: _unref(teacherInfo)[1].file_url || _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_26)]), _unref(teacherInfo).length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("img", {
        src: _unref(teacherInfo)[2].file_url || _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_28)])) : _createCommentVNode("", true)]), _unref(teacherInfo).length == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(teacherInfo)[0].teacher_name) + "、" + _toDisplayString(_unref(teacherInfo)[1].teacher_name), 1)) : _createCommentVNode("", true), _unref(teacherInfo).length >= 3 ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "teacher-name unit text-overflow",
        title: _unref(teacherInfo)[0].teacher_name + '、' + _unref(teacherInfo)[1].teacher_name + '、' + _unref(teacherInfo)[2].teacher_name
      }, [_createTextVNode(_toDisplayString(_unref(teacherInfo)[0].teacher_name) + "、" + _toDisplayString(_unref(teacherInfo)[1].teacher_name) + "、" + _toDisplayString(_unref(teacherInfo)[2].teacher_name) + " ", 1), _withDirectives(_createElementVNode("span", null, "等" + _toDisplayString(_unref(teacherInfo).length) + "名老师", 513), [[_vShow, _unref(teacherInfo).length > 3]])], 8, _hoisted_30)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), __props.lectureData.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [__props.lectureData.live_status == '-2' ? (_openBlock(), _createElementBlock("span", _hoisted_32, "观看直播 >")) : _createCommentVNode("", true), __props.lectureData.live_status == '0' ? (_openBlock(), _createElementBlock("span", _hoisted_33, "未开始")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.lectureData.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [__props.lectureData.live_status == '-2' ? (_openBlock(), _createElementBlock("span", _hoisted_35, "详情 >")) : _createCommentVNode("", true), __props.lectureData.live_status == '0' ? (_openBlock(), _createElementBlock("span", _hoisted_36, "报名 >")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [__props.lectureData.live_status == -2 ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, [_createVNode(_unref(LiveIcon))]), _hoisted_41])) : _createCommentVNode("", true), __props.lectureData.live_status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_45, _toDisplayString(__props.lectureData.live_name), 1), _unref(teacherInfo).length && _unref(teacherInfo).length < 2 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("img", {
        src: _unref(teacherInfo)[0].file_url ? _unref(teacherInfo)[0].file_url : _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_48)]), _createElementVNode("div", _hoisted_49, [_createElementVNode("span", _hoisted_50, _toDisplayString(_unref(teacherInfo).length ? _unref(teacherInfo)[0].teacher_name : '暂无信息'), 1), _createElementVNode("span", {
        class: "intro",
        title: `${_unref(teacherInfo)[0].school_name ? _unref(teacherInfo)[0].school_name : ''} ${__props.lectureData.teacherDtoList[0].college_name ? _unref(teacherInfo)[0].college_name : ''} ${_unref(teacherInfo)[0].job_title ? _unref(teacherInfo)[0].job_title : ''}`
      }, "  " + _toDisplayString(_unref(teacherInfo)[0].school_name) + " " + _toDisplayString(_unref(teacherInfo)[0].college_name) + " " + _toDisplayString(_unref(teacherInfo)[0].job_title), 9, _hoisted_51)])])) : _createCommentVNode("", true), _unref(teacherInfo).length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("img", {
        src: _unref(teacherInfo)[0].file_url || _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_56)]), _createElementVNode("div", _hoisted_57, [_createElementVNode("img", {
        src: _unref(teacherInfo)[1].file_url || _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_58)]), _unref(teacherInfo).length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("img", {
        src: _unref(teacherInfo)[2].file_url || _unref(demoAvatar),
        alt: ""
      }, null, 8, _hoisted_60)])) : _createCommentVNode("", true)]), _unref(teacherInfo).length == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_unref(teacherInfo)[0].teacher_name) + "、" + _toDisplayString(_unref(teacherInfo)[1].teacher_name), 1)) : _createCommentVNode("", true), _unref(teacherInfo).length >= 3 ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "teacher-name unit text-overflow",
        title: _unref(teacherInfo)[0].teacher_name + '、' + _unref(teacherInfo)[1].teacher_name + '、' + _unref(teacherInfo)[2].teacher_name
      }, [_createTextVNode(_toDisplayString(_unref(teacherInfo)[0].teacher_name) + "、" + _toDisplayString(_unref(teacherInfo)[1].teacher_name) + "、" + _toDisplayString(_unref(teacherInfo)[2].teacher_name) + " ", 1), _withDirectives(_createElementVNode("span", null, "等" + _toDisplayString(_unref(teacherInfo).length) + "名老师", 513), [[_vShow, _unref(teacherInfo).length > 3]])], 8, _hoisted_62)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), __props.lectureData.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_63, [__props.lectureData.live_status == '-2' ? (_openBlock(), _createElementBlock("span", _hoisted_64, "观看直播 >")) : _createCommentVNode("", true), __props.lectureData.live_status == '0' ? (_openBlock(), _createElementBlock("span", _hoisted_65, "未开始")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.lectureData.type == 2 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["bottom", __props.lectureData.live_status == '-2' ? '' : 'bottom-between'])
      }, [_createElementVNode("div", _hoisted_66, [_hoisted_67, _createElementVNode("span", null, _toDisplayString(__props.lectureData.address), 1)]), __props.lectureData.live_status == '0' ? (_openBlock(), _createElementBlock("span", _hoisted_68, "报名 >")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)]))], 2);
    };
  }

};